import { RetailKadClientState } from '../../reducers/retail-kad-client/RetailKadClientReducer';
import { RetailKadClientTypes } from '../Type';
import { setSessionStorage, StorageKey } from '@utils/StorageUtils';

export const updateRetailKadClient = (payload: RetailKadClientState) => {
  return (dispatch: any) => {
    dispatch({
      type: RetailKadClientTypes.RetailKadClientUpdate,
      payload,
    });
    setSessionStorage(StorageKey.RetailKadClient, JSON.stringify(payload));
  };
};
